const INITIAL_SESSION_INFO_STATE = {
  isLoggedIn: false,
  isInitialLoading: true,
  userID: null,
  guestUserID: null,
  userPhone: null,
  averageOrderTotal: null,
  userRoles: null,
  isDeviceVerified: null,
  isEmailConfirmed: null,
  raiseCash: 0,
  featureToggles: {
    isUnifiedCart: true,
    isAffiliateProgram: false,
    isSardineEnabled: true,
    isGroupListingsEnabled: true,
    isDecagonEnabled: true
  }
};

export { INITIAL_SESSION_INFO_STATE };
